import { EmotionCache } from '@emotion/utils';
import createCache from '@emotion/cache';

export default function createEmotionCache(): EmotionCache {
  return createCache({ key: 'css' });
}